import { GET_TITLE_LOOKUP_OK, GET_TITLE_LOOKUP_ERR } from "./title.action";

const InitState = {
  error: null,
  content: null,
};

export default function TitleLookupReducer(state = InitState, action) {
  switch (action.type) {
    case GET_TITLE_LOOKUP_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case GET_TITLE_LOOKUP_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }

    default:
      return state;
  }
}
